import { useCallback, useEffect, useState } from "react";
import { Banner, Placeholder, Spinner } from "@telegram-apps/telegram-ui";

import { api } from "../api";
import { useAuth } from "../AuthProvider";
import { TelegramLoginButton } from "../components/TelegramLoginButton";
import type { AuthConfig } from "../types";

export function LoginPage() {
  const { login } = useAuth();
  const [config, setConfig] = useState<AuthConfig | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    api
      .getAuthConfig()
      .then(setConfig)
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : String(e)),
      );
  }, []);

  const onAuth = useCallback(
    (idToken: string) => {
      setSigningIn(true);
      setError(null);
      api
        .loginWithTelegram(idToken)
        .then((res) => login(res.token))
        .catch((e: unknown) => {
          setError(e instanceof Error ? e.message : String(e));
          setSigningIn(false);
        });
    },
    [login],
  );

  const center: React.CSSProperties = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    padding: 24,
    textAlign: "center",
  };

  if (error && !config) {
    return (
      <div style={center}>
        <Placeholder header="Ошибка" description={error} />
      </div>
    );
  }

  if (!config) {
    return (
      <div style={center}>
        <Spinner size="m" />
      </div>
    );
  }

  if (!config.login_enabled || !config.client_id) {
    return (
      <div style={center}>
        <Placeholder
          header="Вход недоступен"
          description="Веб-авторизация не настроена. Откройте приложение через Telegram."
        />
      </div>
    );
  }

  return (
    <div style={center}>
      <Placeholder
        header="МедиаДом"
        description="Войдите через Telegram, чтобы продолжить."
      />
      {signingIn ? (
        <Spinner size="m" />
      ) : (
        <div style={{ width: "100%", maxWidth: 360 }}>
          <TelegramLoginButton
            clientId={config.client_id}
            scriptUrl={config.login_script_url}
            onAuth={onAuth}
            onError={setError}
          />
        </div>
      )}
      {error && (
        <div style={{ width: "100%", maxWidth: 360 }}>
          <Banner type="section" header="Не удалось войти" description={error} />
        </div>
      )}
    </div>
  );
}
